import Helpers from "@/helpers.js"
import Vue from "vue"

export default {
  mfaEnabledForUser(state) {
    Vue.set(state.me, "mfaEnabled", true)
  },
  mfaDisabledForUser(state) {
    Vue.set(state.me, "mfaEnabled", false)
  },
  receiveCurrentUser(state, user) {
    const incomingCurrentUser = { id: user.id, login: user.login, mfaEnabled: user.mfaEnabled, theme: user.theme, displayName: user.displayName, email: user.email, avatarUrl: user.avatarUrl, teams: user.teams, preferences: user.preferences, authenticationToken: user.authenticationToken, isAccountAdmin: user.isAccountAdmin, isAppAdmin: user.isAppAdmin }
    if (!(this.state && this.state.currentUser && this.state.currentUser.me && this.state.currentUser.me.id === user.id)) {
      console.info("CURRENT USER CHANGE")
      // change in current user detected
      if (window.faye) {
        window.faye.addExtension({
          outgoing: (message, callback) => {
            if (!message.ext) {
              message.ext = {}
            }
            message.ext.authentication_token = incomingCurrentUser.authenticationToken
            callback(message)
          },
        })
      }
    } else {
      console.error("NO CURRENT USER CHANGE")
    }
    this.state.currentUser.isAccountAdmin = user.isAccountAdmin
    this.state.currentUser.isAppAdmin = !!user.isAppAdmin
    this.state.currentUser.me = incomingCurrentUser
    this.state.currentUser.isCurrentUserLoading = false
  },
  updateCurrentUserPageSize(state, newPageSize) {
    state.me.preferences.pageSize = newPageSize
  },
  setUnifiedSearch(state, enabled) {
    if (!state.me.preferences) {
      Vue.set(state.me, "preferences", {})
    }
    Vue.set(state.me.preferences, "unifiedSearch", enabled)
  },
  filterIconToggle(state, { id, enabled }) {
    state.me.preferences.timeline[id] = enabled
  },
  setCaseTypes(state, data) {
    state.caseTypes = Array.isArray(data) ? data : []
  },
  setNotifications(state, notifications) {
    Vue.set(state, "notifications", notifications)
  },
  setupRecentNotifications(state, notifications) {
    const recent = []
    let currentDay = { date: "", notifications: [] }
    notifications.forEach((notification) => {
      const currentDate = Helpers.formatDate(notification.createdAt, "YYYY-M-D")
      if (currentDate !== currentDay.date) {
        if (currentDay.notifications.length > 0) {
          recent.push(currentDay)
        }
        currentDay = {
          date: currentDate,
          notifications: [],
        }
      }
      currentDay.notifications.push(notification)
    })
    if (currentDay.notifications.length > 0) {
      recent.push(currentDay)
    }
    Vue.set(state, "recentNotifications", recent)
  },
  setupCaseNotifications(state, notifications) {
    const recent = []
    let currentDay = { date: "", notifications: [] }
    notifications.forEach((notification) => {
      const currentDate = Helpers.formatDate(notification.createdAt, "YYYY-M-D")
      if (currentDate !== currentDay.date) {
        if (currentDay.notifications.length > 0) {
          recent.push(currentDay)
        }
        currentDay = {
          date: currentDate,
          notifications: [],
        }
      }
      if (notification.notificationType === "case-event") {
        currentDay.notifications.push(notification)
      }
    })
    if (currentDay.notifications.length > 0) {
      recent.push(currentDay)
    }
    Vue.set(state, "caseNotifications", recent)
  },
  setSubscriptions(state, subs) {
    state.subscriptions = subs
  },
  addNewSla(state, sla) {
    const updatedSLC = state.account.serviceLevelCriteria || []
    updatedSLC.push({
      id: sla.id,
      bucketId: sla.bucketId,
      name: sla.name,
      inJeopardyThreshold: sla.inJeopardyThreshold,
      inBreachThreshold: sla.inBreachThreshold,
      enabled: sla.enabled,
    })
    Vue.set(state.account, "serviceLevelCriteria", updatedSLC)
  },
  removeSla(state, id) {
    const updatedSLC = state.account.serviceLevelCriteria || []
    const slas = updatedSLC.map((sla) => sla.id)
    const index = slas.indexOf(id)

    if (index >= 0) updatedSLC.splice(index, 1)
    Vue.set(state.account, "serviceLevelCriteria", updatedSLC)
  },
  addBucketGroup(state, data) {
    const allCaseTypes = state.caseTypes && Array.isArray(state.caseTypes) ? state.caseTypes : []
    const caseType = allCaseTypes.find((caseType) => {
      return parseInt(caseType.id) === parseInt(data.caseTypeId)
    })
    if (caseType) {
      const caseTypeIndex = allCaseTypes.indexOf(caseType)
      const newGroup = {
        id: data.id,
        name: data.name,
        position: data.position,
        buckets: data.buckets,
      }
      caseType.bucketGroups.push(newGroup)
      state.caseTypes[caseTypeIndex] = caseType
    }
  },
  removeBucketGroup(state, data) {
    if (!state.caseTypes || !Array.isArray(state.caseTypes)) return
    const allCaseTypes = state.caseTypes
    const caseType = allCaseTypes.find((caseType) => {
      return parseInt(caseType.id) === parseInt(data.caseTypeId)
    })
    if (!caseType || !caseType.bucketGroups) return
    const caseTypeIndex = allCaseTypes.indexOf(caseType)
    const bucketGroups = caseType.bucketGroups.map((bg) => bg.id)
    const index = bucketGroups.indexOf(data.bucketGroupId)
    if (index >= 0) {
      state.caseTypes[caseTypeIndex].bucketGroups.splice(index, 1)
    }
  },
  setAssignedTasks(state, tasks) {
    Vue.set(state, "assignedTasks", tasks)
  },
  taskStarted(state) {
    state.taskRunning = true
  },
  taskComplete(state) {
    state.taskRunning = false
  },
  taskUpdate(state, result) {
    state.taskResult = result
  },
  setAuditEnabled(state, enabled) {
    state.account.auditEnabled = !!enabled
  },
  setAccountDetails(state, account) {
    if (!account) return
    state.account.id = account.id
    state.account.title = account.title
    state.account.nickname = account.nickname
    state.account.timezone = account.timezone
    if (account.defaultTeam !== undefined) {
      Vue.set(state.account, "defaultTeam", account.defaultTeam)
    }
    state.account.chatBriefing = account.chatBriefing
    state.account.chatReports = account.chatReports != null ? account.chatReports : {}
    state.account.chatMemoryEnabled = account.chatMemoryEnabled
    if (account.auditEnabled !== undefined) {
      state.account.auditEnabled = !!account.auditEnabled
    }
    state.account.refreshTokenExpiryHours = account.refreshTokenExpiryHours || 24
    state.account.adminConsoleToken = account.adminConsoleToken
    state.account.colourScheme = account.colourScheme
    const lifecycleAttrs = account.scriptEngineAttrs && account.scriptEngineAttrs.attrs
    if (typeof lifecycleAttrs === "string") {
      state.account.lifeCycleCallbacks = lifecycleAttrs
    } else if (lifecycleAttrs != null) {
      state.account.lifeCycleCallbacks = JSON.stringify(lifecycleAttrs, null, 2)
    } else {
      state.account.lifeCycleCallbacks = ""
    }
    state.account.llmApiKeyConfigured = !!account.llmApiKeyConfigured
    state.account.changedLlmApiKey = ""
    if (account.oidcSso !== undefined) {
      Vue.set(state.account, "oidcSso", account.oidcSso)
    }
    state.account.changedOidcSso = null
    if (account.serviceLevelCriteria) {
      state.account.serviceLevelCriteria = account.serviceLevelCriteria
    }
    if (account.emailAccounts) {
      Vue.set(state.account, "emailAccounts", [...account.emailAccounts])
    }
  },
  setSavedSearchResults(state, searchData) {
    const savedSearch = state.account.savedSearches.find((search) => {
      return parseInt(search.id) === parseInt(searchData.savedSearchId)
    })
    savedSearch.contents = searchData.contents
  },
  setSavedSearches(state, savedSearches) {
    Vue.set(state.account, "savedSearches", [...savedSearches])
  },
  setSavedSearchesTotals(state, updatedSavedSearches) {
    for (const uss of updatedSavedSearches) {
      const savedSearch = state.account.savedSearches.find((search) => {
        return "" + search.id === "" + uss.id
      })
      if (savedSearch.contents) {
        savedSearch.contents.total = uss.contents.total
      }
    }
    Vue.set(state.account, "savedSearches", [...state.account.savedSearches])
  },
  removeMessageFromSavedSearch(state, { savedSearchId, messageId }) {
    const savedSearch = state.account.savedSearches.find((search) => {
      return parseInt(search.id) === parseInt(savedSearchId)
    })
    if (savedSearch && savedSearch.contents && savedSearch.contents.messages) {
      const messageIndex = savedSearch.contents.messages.findIndex((msg) => {
        return parseInt(msg.id) === parseInt(messageId)
      })
      if (messageIndex >= 0) {
        savedSearch.contents.messages.splice(messageIndex, 1)
        // Update total count
        if (savedSearch.contents.total) {
          savedSearch.contents.total = Math.max(0, savedSearch.contents.total - 1)
        }
        Vue.set(state.account, "savedSearches", [...state.account.savedSearches])
      }
    }
  },
  addSavedSearch(state, data) {
    const updatedSearches = state.account.savedSearches
    updatedSearches.push(data.savedSearch)
    Vue.set(state.account, "savedSearches", [...updatedSearches])
  },
  removeSavedSearch(state, data) {
    const ids = state.account.savedSearches.map((search) => search.id)
    const index = ids.indexOf(data.savedSearchId)
    state.account.savedSearches.splice(index, 1)
    Vue.set(state.account, "savedSearches", [...state.account.savedSearches])
  },
  renameSavedSearch(state, data) {
    const ids = state.account.savedSearches.map((search) => search.id)
    const index = ids.indexOf(data.savedSearchId)
    state.account.savedSearches[index].name = data.newSearchName
    Vue.set(state.account, "savedSearches", [...state.account.savedSearches])
  },
  addNewEmailAccount(state) {
    state.account.emailAccounts.push({
      name: "Default",
      description: "",
      isDefault: false,
      sendChannel: "MailgunConnector",
      receiveChannel: "MailgunConnector",
      imapDetails: { host: "outlook.office365.com", port: 993, login: "", password: "", ssl: false, startTLS: true, enabled: true }, 
      smtpDetails: { host: "smtp.office365.com", port: 587, login: "", password: "", ssl: false, startTLS: true, enabled: true, replyToEmailAddress: "", useReplyToAsFrom: false } 
    })
    Vue.set(state.account, "emailAccounts", [...state.account.emailAccounts])
  },
  upsertEmailAccount(state, updatedEmailAccount) {
    if (!state.account || !Array.isArray(state.account.emailAccounts)) {
      return
    }
    const emailAccounts = state.account.emailAccounts
    const targetIndex = emailAccounts.findIndex((account) => parseInt(account.id, 10) === parseInt(updatedEmailAccount.id, 10))
    if (targetIndex === -1) {
      emailAccounts.push(updatedEmailAccount)
    } else {
      Vue.set(emailAccounts, targetIndex, { ...emailAccounts[targetIndex], ...updatedEmailAccount })
    }
    Vue.set(state.account, "emailAccounts", [...emailAccounts])
  },
  deleteEmailAccount(state, index) {
    state.account.emailAccounts.splice(index, 1)
    Vue.set(state.account, "emailAccounts", [...state.account.emailAccounts])
  },
}
